import CheckIcon from '@mui/icons-material/Check';
import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const DialogCard = superstyled({
  tag: Card,
  name: 'Package',
  slot: 'DialogCard',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    borderRadius: theme.shape.rounded['2xl'],

    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(3, 3, 4),
    },
  }),
});

export const CardTop = superstyled({
  tag: Stack,
  name: 'Package',
  slot: 'CardTop',
  styles: ({ theme }) => ({
    flexDirection: 'column',
    alignItems: 'flex-start',

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
    },
  }),
});

export const CardTitle = superstyled({
  tag: Box,
  name: 'Package',
  slot: 'CardTitle',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: theme.spacing(1),

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
});

export const IconContainer = superstyled({
  tag: Card,
  name: 'Package',
  slot: 'IconContainer',
  styles: ({ theme }) => ({
    width: '3rem',
    minWidth: '3rem',
    height: '3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.shape.rounded.md,
  }),
});

export const Item = superstyled({
  tag: Box,
  name: 'Package',
  slot: 'Item',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 0),
  }),
});

export const FeatureCheckIcon = superstyled({
  tag: CheckIcon,
  name: 'Package',
  slot: 'FeatureCheckIcon',
  styles: {
    fontSize: 20,
  },
});

export const DisabledFeatureText = superstyled({
  tag: Text,
  name: 'Package',
  slot: 'DisabledFeatureText',
  styles: {
    textDecoration: 'line-through',
  },
});
